import { Criticality, VariableInfo } from '@/lib/PlannerDTOs';

export const defaultVariable: VariableInfo = {
  name: 'TestVar',
  backend: 'api-gateway',
  techFamily: 'DAXEXP',
  domain: 'primary',
  desc: '',
  state: 'REQUESTED',
  public: true,
  enabled: true,
  type: 'boolean',
  facets: ['svc', 'bkg'],
  version: 0,
  owner: 'Gautam Jethwani',
  scriptable: true,
  criticality: Criticality.NonCritical,
  lastRolloutUpdatedTime: new Date(),
  hot: false,
  assignBy: 'pax',
};
